import { BarChart3 } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="py-12 border-t border-border">
      <div className="container px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <img 
              src="/sharpex-logotype-2.png" 
              alt="Sharpexio" 
              className="h-36 w-auto transition-transform duration-300 hover:scale-105"
            />
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm text-muted-foreground">
            <Link to="/terms" className="hover:text-foreground transition-colors">Terms</Link>
            <Link to="/privacy" className="hover:text-foreground transition-colors">Privacy</Link>
            <Link to="/docs" className="hover:text-foreground transition-colors">Docs</Link>
            <a href="https://x.com/sharpexio" target="_blank" rel="noopener noreferrer" className="data-link">
              X
            </a>
          </div>

          {/* Disclaimer */}
          <p className="text-xs text-muted-foreground text-center md:text-right max-w-sm">
            Not financial advice. Past performance does not guarantee future results.
          </p>
        </div>
      </div>
    </footer>
  );
};
